<template>
    <div
        class="question-row question-row-range-slider"
        :data-question-to="props.content.next_question?.value"
        :data-conditions="conditions"
        :data-lead-service-name="props.content.lead_service_name.value || `extradata-question-${index}`"
    >
        <zoe-atom-range-slider
            :value="fieldValue"
            :min="minimum"
            :max="maximum"
            :steps="steps"
            :settings="{
                showMinMaxValues: content.value_settings.show_min_max_values?.value || false,
                showThousandsSeparator: content.value_settings.show_thousand_separators.value,
                prefix: content.value_settings.prefix.value,
                suffix: content.value_settings.suffix.value,
            }"
            @updateValue="fieldValue = $event"
        />
    </div>

    <div class="question-row question-row-button">
        <button
            class="question-button-next button"
            type="button"
            value="next"
            data-showstopper="none"
            data-question-to="next_question"
            @click="check"
        >
            <zoe-atom-text
                :item="props.content.button.label.value"
            />
        </button>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { addExtraData, getQuestionName, questionProps, storeExtraData } from '../../../../../mixins/quiz/v2.0.0/question';

import { checkCompleted } from '../../../../../mixins/quiz/v2.0.0/checks';
import { getNextQuestion } from '../../../../../mixins/quiz/v2.0.0/get-next-question';

import ZoeAtomText from '../../../../atoms/text/v1.0.0/zoe-atom-text.vue';
import ZoeAtomRangeSlider from '@atoms/range-slider/zoe-atom-range-slider.vue';
import stripHtml from '@mixins/utils/strip-html';

const store = useStore();
const props = defineProps(questionProps);

const name = getQuestionName(props);
const uuid = ref(props.content?._info?.uuid);

const start = parseInt(props.content.value_settings.start_value.value) || 5000;
const minimum = parseInt(props.content.value_settings.min_value.value) || 0;
const maximum = parseInt(props.content.value_settings.max_value.value) || 10000;
const steps = parseInt(props.content.value_settings.steps.value) || 50;

onMounted(() => {
    addExtraData(name, {
        name,
        value: start,
        mask: '',
        validator: 'notEmpty',
        uuid: uuid.value,
        question: stripHtml(props.content.text.value),
        sendData: props.content.send_to_lead_service?.value !== false,
    });
});

const conditions = computed(components => {
    return JSON.stringify(props.content.answers);
});

const fieldValue = computed({
    get: () => store.state.quiz.extradata[name]?.value || 0,
    set: value => {
        store.state.quiz.extradata[name].label = value;
        return store.state.quiz.extradata[name].value = value;
    },
});

const check = event => {
    const questionWrapper = event.target.closest('.question');
    const inputContainer = questionWrapper.querySelector('.question-row-range-slider');
    const buttons = questionWrapper.querySelectorAll('.button');
    const delay = questionWrapper.dataset.delay ? parseInt(questionWrapper.dataset.delay) : 0;
    const conditions = JSON.parse(inputContainer.getAttribute('data-conditions'));

    const linkedFormInputIdentifier = '';
    const worktypeId = '';
    const enquiryDashboardRedirectVersion = '';

    const sliderValue = store.getters['quiz/getExtraData']('value', name);

    let nextQuestion = getNextQuestion(inputContainer.dataset.questionTo || '', store.state.quiz.currentQuestion);

    let response = false;
    let showstopper = false;

    conditions.forEach(condition => {
        if (response === false) {
            const valueFrom = condition.value_from.value;
            const valueTo = condition.value_to.value;

            if (sliderValue >= valueFrom && sliderValue <= valueTo) {
                if (condition.showstopper.value !== '') {
                    if (condition.showstopper.hide_showstopper_close_button) store.commit('dialog/preventClose');
                    store.commit('dialog/show', condition.showstopper.value);
                    showstopper = true;
                    return;
                } else {
                    if (store.state.quiz.advancedFlow) {
                        nextQuestion = getNextQuestion(condition.next_question.value || '', store.state.quiz.currentQuestion);
                    }
                }

                response = true;
            }
        }
    });

    if (showstopper) return;

    checkCompleted(name, buttons, props.preHook, nextQuestion, props.afterHook, sliderValue, linkedFormInputIdentifier, worktypeId, enquiryDashboardRedirectVersion, delay);
    storeExtraData(name, 'label', sliderValue);
    storeExtraData(name, 'value', sliderValue);
};
</script>

<style lang="scss">
@use 'zoe-quiz-range-slider';
</style>
